import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';

const useStyles = makeStyles({
    '@keyframes translate': {
        '0%': {
            transform: 'translate(0px)',
        },
        '100%': {
            transform: 'translate(240px)',
        },
    },
    root: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        zIndex: 99999,
    },
    customLogo: {
        position: 'absolute',
        left: 'calc((100vw - 240px) / 2)',
        top: '180px',
        width: '240px',
    },
    customLogoOverlay: {
        position: 'absolute',
        left: 'calc((100vw - 240px) / 2)',
        top: '180px',
        width: '240px',
        height: '360px',
        backgroundColor: '#ffffffaa',
        animation: '$translate 3s linear infinite',
    },
    customLogoLandscape: {
        position: 'absolute',
        left: 'calc((100vw - 100vw *.3) - 214px / 2)',
        top: '100px',
        width: '240px',
    },
    customLogoOverlayLandscape: {
        position: 'absolute',
        left: 'calc((100vw - 100vw *.3) - 214px / 2)',
        top: '100px',
        width: '240px',
        height: '360px',
        backgroundColor: '#ffffffaa',
        animation: '$translate 3s linear infinite',
    },
});

export default function Loader() {
    const isPortrait = useMediaQuery('(orientation: portrait)');
    const [logoUrl, setLogoUrl] = React.useState<string>('');
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });
    
    React.useEffect(() => {
        setLogoUrl(checkOutState.state.restaurantLoaderUrl === null ? '' : checkOutState.state.restaurantLoaderUrl);
        
    }, [checkOutState.state.restaurantLogoUrl, checkOutState.state.skin.use_custom_skin]);

    return (
        <div className={classes.root}>

            {logoUrl !== '' &&
                <div>
                    <img className={clsx({
                        [classes.customLogo]: isPortrait,
                        [classes.customLogoLandscape]: !isPortrait,
                    })} src={logoUrl} />
                    <div 
                        className={clsx({
                            [classes.customLogoOverlay]: isPortrait,
                            [classes.customLogoOverlayLandscape]: !isPortrait,
                        })}>
                    </div>
                </div>
            }
        
      </div>
    );
};